import React, { FC } from 'react'
import styles from 'styles/components/header.module.scss'
import { useFixedBackface } from 'hooks/effect'

type Props = {
  open: boolean
  toggle: () => void
}

const SubHeaderBackground: FC<Props> = React.memo((props) => {
  const { open, toggle } = props
  useFixedBackface(open, [open])
  return <div className={styles.subheader__background} onClick={toggle} role={'none'} />
})

export default SubHeaderBackground
